var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M24.266 12.415c0-.816-.066-1.636-.207-2.438H12.74v4.62h6.482a5.55 5.55 0 0 1-2.399 3.647v2.998h3.867c2.271-2.09 3.576-5.176 3.576-8.827"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M12.74 24.14c3.237 0 5.966-1.063 7.955-2.898l-3.867-2.998c-1.076.732-2.465 1.146-4.083 1.146-3.131 0-5.786-2.111-6.738-4.951h-3.99v3.09a12 12 0 0 0 10.723 6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M6.003 14.439a7.2 7.2 0 0 1 0-4.595v-3.09H2.017a12.01 12.01 0 0 0 0 10.776z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M12.74 4.888a6.52 6.52 0 0 1 4.603 1.8L20.77 3.26A11.53 11.53 0 0 0 12.74.14 12 12 0 0 0 2.017 6.753l3.986 3.091C6.95 7 9.609 4.888 12.74 4.888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.139h24v24H.5z"
  })))));
};
export default SvgGoogle;